export default "__VITE_ASSET__P_98WMC4__"